import { createTabSystem, GetTabsProps } from 'common/types/tabsV2';
import { TabV2Item } from 'common/ui/TabsV2';

const candidateProfileAnalysisTabs = [
  'Details',
  'Conversation',
  'Interview transcripts',
  'Notes'
] as const;

export type CandidateProfileAnalysisTab =
  (typeof candidateProfileAnalysisTabs)[number];

const candidateProfileAnalysisTabSystem = createTabSystem(
  candidateProfileAnalysisTabs
);

type GetCandidateProfileAnalysisTabsProps =
  GetTabsProps<CandidateProfileAnalysisTab> & {
    calendarBookingId: string | null;
  };

export const getCandidateProfileAnalysisTabs = (
  props: GetCandidateProfileAnalysisTabsProps
): TabV2Item[] => {
  const tabs = candidateProfileAnalysisTabSystem.createTabs(props);

  if (!props.calendarBookingId) {
    return tabs.filter((tab) => tab.value !== 'Interview transcripts');
  }

  return tabs;
};
